import { createFileRoute, redirect } from '@tanstack/react-router';

interface WelcomeSearch {
	magicCode?: string;
	auth?: string;
}

export const Route = createFileRoute('/welcome')({
	validateSearch: (search: Record<string, unknown>): WelcomeSearch => ({
		magicCode: search.magicCode as string | undefined,
		auth: search.auth as string | undefined,
	}),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: '/access/authentication',
			search: {
				auth: search.auth,
				redirect: '/access/overview',
			},
		});
	},
});
